<div
    (pointerenter)="$event.pressure !== 0 && ttMouseenter.emit($event)"
    (pointerover)="$event.pressure !== 0 && ttMouseenter.emit($event)"
    (pointerleave)="ttMouseleave.emit($event)"
    (pointerup)="ttMouseleave.emit($event)"
>
    <div
        class="innerlist"
        style="background-color: var(--tt-primary-color); color: white; padding: 0.2rem; border-radius: 0.3rem"
        [id]="ttId"
        cdkDropList
        [cdkDropListData]="resources"
        (cdkDropListEntered)="itemDragEntered($event)"
        (cdkDropListDropped)="dropDropZone($event)"
        [cdkDropListConnectedTo]="connectedLists"
    >
        <div *ngFor="let resource2 of resources" cdkDrag [cdkDragData]="resource2">test</div>
        {{ $any(ttItem)["item_name"] }}
    </div>
</div>
